<div class="modal-header">
    <h2
        class="modal-title"
        id="exampleModalLabel">
        Delete Query ?
    </h2>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">Are you sure you want to delete this query ?</div>

<div class="modal-footer">
    <button
        class="button button--danger"
        (click)="deleteQuery()">
        Delete
    </button>
    <button
        type="button"
        class="button button--outline"
        (click)="activeModal.dismiss()">
        Cancel
    </button>
</div>
